export default __webpack_public_path__ + "static/media/check2-000000.4a9698ad.svg";